import React, { Component } from "react";
import { Button, Modal, Radio } from "react-bootstrap";

class CallOutcomeModal extends Component {
  state = {
    selectedOutcome: ""
  };

  handleOutcomeChange = (e) => {
    this.setState({ selectedOutcome: e.target.value });
  };

  handleTCSResponse = (isTCS) => {
    // For incoming calls, submit immediately with TCS response
    this.props.onSubmit(null, isTCS);
    this.setState({ selectedOutcome: "" });
  };

  handleSubmit = () => {
    const { selectedOutcome } = this.state;
    if (selectedOutcome) {
      // For outgoing calls, submit with outcome (no TCS flag)
      this.props.onSubmit(selectedOutcome, null);
      this.setState({ selectedOutcome: "" });
    }
  };

  render() {
    const { showModal, isIncoming } = this.props;
    const { selectedOutcome } = this.state;

    return (
      <Modal 
        show={showModal} 
        backdrop="static" 
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{isIncoming ? "TCS Call?" : "Call Outcome"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isIncoming ? (
            <div>
              <p>Was this a TCS (Trial Coaching Session) call?</p>
              <div style={{ marginTop: 20 }}>
                <Button
                  bsStyle="primary"
                  onClick={() => this.handleTCSResponse(true)}
                  style={{ marginRight: 10 }}
                >
                  Yes - TCS Call
                </Button>
                <Button
                  onClick={() => this.handleTCSResponse(false)}
                >
                  No - Regular Call
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <p>Please select the outcome of this call:</p>
              <div style={{ marginTop: 20 }}>
                <Radio
                  name="outcome"
                  value="spoke_to_person"
                  checked={selectedOutcome === "spoke_to_person"}
                  onChange={this.handleOutcomeChange}
                >
                  Spoke to Person - Regular TCS Call
                </Radio>
                <Radio
                  name="outcome"
                  value="spoke_to_person_irregular_TCS_Call"
                  checked={selectedOutcome === "spoke_to_person_irregular_TCS_Call"}
                  onChange={this.handleOutcomeChange}
                >
                  Spoke to Person - Irregular TCS Call
                </Radio>
                <Radio
                  name="outcome"
                  value="left_voicemail"
                  checked={selectedOutcome === "left_voicemail"}
                  onChange={this.handleOutcomeChange}
                >
                  Left voicemail
                </Radio>
                <Radio
                  name="outcome"
                  value="no_answer"
                  checked={selectedOutcome === "no_answer"}
                  onChange={this.handleOutcomeChange}
                >
                  No answer (hung up, no message)
                </Radio>
                <Radio
                  name="outcome"
                  value="wrong_number"
                  checked={selectedOutcome === "wrong_number"}
                  onChange={this.handleOutcomeChange}
                >
                  Wrong number
                </Radio>
                <Radio
                  name="outcome"
                  value="call_failed"
                  checked={selectedOutcome === "call_failed"}
                  onChange={this.handleOutcomeChange}
                >
                  Call failed
                </Radio>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isIncoming && (
            <Button
              bsStyle="primary"
              onClick={this.handleSubmit}
              disabled={!selectedOutcome}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CallOutcomeModal;
